import * as types from "../types";

const initialState = {
  isBlobUploaded: false,
  csvFileName: "",
  uploadedFileName: "",
  isError: false,
  showModalToEnterOTP: false,
  isUserVerified: false,
  fileData: [],
  shouldFetchFileData: false,
  globalConfigParams: [],
  openPopupForStopCall:false,
  stopCallResponse:null
};

export default function initiateCall(
  state = initialState,
  { type, payload } = {}
) {
  switch (type) {
    case types.PUT_CSV_FILE_IN_BLOB_SUCCESS:
      return {
        ...state,
        isBlobUploaded: true,
        csvFileName: payload.csvFileName,
        uploadedFileName: payload.uploadedFileName,
        isError: false,
        shouldFetchFileData: true,
        isUserVerified: false,
      };

    case types.PUT_CSV_FILE_IN_BLOB_FAILED:
      return {
        ...state,
        isBlobUploaded: false,
        csvFileName: "",
        uploadedFileName: "",
        isError: true,
        shouldFetchFileData: false,
        isUserVerified: false,
      };

    case types.POST_OTP_TO_USER_SUCCESS:
      return {
        ...state,
        isError: false,
        showModalToEnterOTP: true,
        shouldFetchFileData: false,
        isUserVerified: false,
      };
    case types.POST_OTP_TO_USER_FAILED:
      return {
        ...state,
        isError: true,
        showModalToEnterOTP: false,
        isUserVerified: false,
        shouldFetchFileData: false,
      };
    case types.CLOSE_OTP_MODAL_SUCCESS:
      return {
        ...state,
        isError: false,
        showModalToEnterOTP: false,
        isUserVerified: false,
        shouldFetchFileData: false,
      };
    case types.VERIFY_OTP_WITH_USER_SUCCESS:
      return {
        ...state,
        isError: false,
        showModalToEnterOTP: false,
        isUserVerified: true,
        shouldFetchFileData: false,
      };
    case types.VERIFY_OTP_WITH_USER_FAILED:
      return {
        ...state,
        isError: true,
        showModalToEnterOTP: false,
        isUserVerified: false,
        shouldFetchFileData: false,
      };
    case types.GET_FILES_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        fileData: payload.fileData,
        shouldFetchFileData: false,
      };
    case types.GET_FILES_DATA_FAILED:
      return {
        ...state,
        isError: true,
        fileData: [],
        shouldFetchFileData: false,
      };
    case types.UPDATE_SCHEDULE_CALL_TIME_SUCCESS:
      return {
        ...state,
        isError: false,
        shouldFetchFileData: true,
      };
    case types.UPDATE_SCHEDULE_CALL_TIME_FAILED:
      return {
        ...state,
        isError: true,
        shouldFetchFileData: false,
      };
    
    case types.UPDATE_STOP_CALL_SUCCESS:
        return {
          ...state,
          openPopupForStopCall:true,
          stopCallResponse:payload
        };
    case types.UPDATE_STOP_CALL_FAILED:
        return {
          ...state,
          shouldFetchFileData: true,
          openPopupForStopCall:false,
          stopCallResponse:null
        };
    case types.SET_MODAL_STOP_CALL_SUCCESS:
        return {
          ...state,
          openPopupForStopCall:false,
          stopCallResponse:null
        };
    case types.DISABLE_FILE_SUCCESS:
        return {
          ...state,
          shouldFetchFileData: true,
        };
    case types.USER_LOGOUT:
      return {
        ...state,
        isBlobUploaded: false,
        csvFileName: "",
        uploadedFileName: "",
        isError: false,
        showModalToEnterOTP: false,
        isUserVerified: false,
        fileData: [],
        shouldFetchFileData: false,
      };
    case types.FETCH_GLOBAL_CONFIG_SUCCESS:
      return {
        ...state,
        globalConfigParams:payload.globalConfigParams
      };
    default:
      return state;
  }
}
